import React, { Component } from 'react'
import { RightArrow } from './icons'
import Link from '../utils/link'
import Select from 'react-select'
import { propertyQuery } from '../templates/property'

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

class EnquiryForm extends Component {

  state = {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    address: '',
    enquiry: '',
    address: this.props.property,
    agent: this.props.agent,
    register: '',
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleSubmit = e => {

    e.preventDefault()

    if (!this.refs.form.checkValidity()) return false

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": this.refs.form.getAttribute("name"),
        ...this.state
      })
    })
    .then(() => {
      this.setState({result: 'success', msg: ''})
    })
    .catch(error => this.setState({result: 'fail', msg: error}))
  }

  handleSubmit = async (e) => {
    e.preventDefault()
    this.setState({ result: 'success' })
    const data = encode({ 
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      email: this.state.email,
      phone: this.state.phone,
      address: this.props.property,
      enquiry: this.state.enquiry,
      address: this.state.address,
      agent: this.state.agent,
      register: this.state.register,
    })
    await fetch("https://hooks.zapier.com/hooks/catch/2181815/bzo750q/?"+data).then((res) => {
      this.setState({ result: "success" })
    })
    .catch(error => this.setState({ result: "fail", msg: error }))
  }

  render() {

    let { address } = this.state

    let props = {
      ref: 'form',
      name: 'enquiry',
      className: 'form',
      onSubmit: this.handleSubmit,
    }

    if (this.state.result === 'success')
    return (
      <p className='contact__success'>Thank you.</p>
    )

    return (
      <form {...props}>

        <div className='form__row form__row--double form__row--double-mobile'>

          <div className='form__column'>
            <label htmlFor='first-name-field'> First Name </label>
            <input type='text' name='first_name' id='first-name-field' placeholder='—' onChange={this.handleChange} required />
          </div>

          <div className='form__column'>
            <label htmlFor="last-name-field"> Last Name </label>
            <input type='text' name='last_name' id='last-name-field' placeholder='—' onChange={this.handleChange} required />
          </div>
          
        </div>

        <div className='form__row form__row--double form__row--double-mobile'>

          <div className='form__column'>
            <label htmlFor='email-field'>Your Email</label>
            <input type='email' name='email' id='email-field' placeholder='—' onChange={this.handleChange} required  />
          </div>

          <div className='form__column'>
            <label htmlFor='phone-field'> Contact Number </label>
            <input type='text' name='phone' id='phone-field' placeholder='—' onChange={this.handleChange} required  />
          </div>
         
        </div>

        <div className='form__row form__row--hidden'>
          <label htmlFor='subject-field'>Subject</label>
          <input type='text' name='subject' id='subject-field' value={this.props.property} onChange={this.handleChange} required />
        </div>

        <div className='form__row form__row--hidden'>
          <label htmlFor='agent'>Agent</label>
          <input type='text' name='agent' id='agent' value={this.props.agent} onChange={this.handleChange} />
        </div>

        <div className='form__row form__textarea'>

          <label htmlFor='enquiry-field'>Your Enquiry</label>
          
          <textarea id='enquiry-field' name='enquiry' placeholder='' onChange={this.handleChange} />

        </div>
        <div className='form__row form__row--submit'>

          <div className='form__checkbox register-checkbox'>
            
            <input type='checkbox' name='register' id='register-field' className='form__input' onChange={this.handleChange}  />
            
            <label htmlFor='register-field'>
              Sign up to Gartland’s property news
              <Link to='/privacy-policy/'>Privacy Policy</Link>
            </label>
            
          </div>

          <button type='submit' className='btn btn--border'>Send your enquiry</button>
        </div>

      </form>
    )
  }
}

export default EnquiryForm